import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

const GROUP = 'group'
const GROUP_COURSE = 'group_course'
const CHAPTER = 'course_chapter'
const SESSION = 'session'
const TEACHER = 'author'
const STATUS = 'status'

const CATEGORY = 'course_component'
const SUBMISSION_TYPE = 'submission_type'
const ASSESSMENT_TYPE = 'assessment_type'
const MATERIALS = 'materials'

const ACADEMIC_PERIOD = 'academic_period'
const EFFECTIVE_DATETIME = 'effective_datetime'
const DUE_DATETIME = 'due_datetime'
const RESUBMISSION_DATETIME = 'resubmission_datetime'
const EXPECTED_TIME = 'expected_time'
const EXPECTED_TIME_TYPE = 'expected_time_type'

const TITLE = 'title'
const COLOR = 'color_hex_code'
const SCORE_TYPE = 'score_type'
const DESCRIPTION = 'description'
const ATTACHMENTS = 'attachments'

const ALLOW_SUBMISSIONS = 'are_submissions_allowed'
const ALLOW_COMMENTS = 'are_comments_allowed'
const ALLOW_ACCOMMODATION = 'is_accommodation_allowed'
const ALLOW_MODIFICATION = 'is_modification_allowed'

const ACCOMMODATIONS = 'accommodations'
const MODIFICATIONS = 'modifications'

const EFFECTIVE_DATETIME_EMAIL_NOTIFICATIONS = 'effective_datetime_email_notifications'
const DUE_DATETIME_EMAIL_NOTIFICATIONS = 'due_datetime_email_notifications'

const RUBRIC = 'rubric'
const POINTS_POSSIBLE = 'points_maximum'
const IMPORTANCE = 'importance'
const NUMBER_OF_ATTEMPTS = 'number_of_attempts'
const HAS_EXTRA_CREDIT = 'has_extra_credit'
const HAS_ENTRY_POINTS = 'has_entry_points'
const ENTRY_POINTS = 'entry_points'
const EXTRA_CREDIT = 'extra_credit'
const COUNTS_TO_FINAL_GRADE = 'counts_to_final_grade'
const ASSESSMENT_PROBE = 'assessment_probe'

const GRADING_COMPONENTS = 'grading_components'
// const IMPORTANCE = 'importance'
// const HIDE_FROM_STUDENTS = 'hide_from_students'

const RECIPIENT_TYPE = 'recipient_type'
const STUDENTS = 'students'
const TEAM = 'group_course_team'

const HAS_PEER_ASSESSMENT = 'has_peer_assessment'
const IS_PEER_ASSESSMENT_ANONYMOUS = 'is_peer_assessment_anonymous'
const PEER_ASSESSMENT_DUE_DATETIME = 'peer_assessment_due_datetime'
const PEER_ASSESSMENT_SUBMISSIONS_COUNT = 'peer_assessment_submissions_count'
const PEER_ASSESSMENT_INSTRUCTIONS = 'peer_assessment_instructions'

const today = new Date()
today.setHours(0, 0, 0, 0)

/**
 * Form model
 */
const formModel = () => {
  return {
    // Section 1
    [GROUP]: {
      label: `${t('common.group')}`,
      name: GROUP,
      required: true,
    },
    [GROUP_COURSE]: {
      label: `${t('common.course')}`,
      name: GROUP_COURSE,
      required: true,
    },
    [CHAPTER]: {
      label: `${t('common.chapter')}`,
      name: CHAPTER,
    },
    [SESSION]: {
      label: `${t('common.session')}`,
      name: SESSION,
    },
    [TEACHER]: {
      label: `${t('common.teacher')}`,
      name: TEACHER,
    },
    [STATUS]: {
      label: `${t('common.status')}`,
      name: STATUS,
    },
    
    //Details

    [CATEGORY]: {
      label: `${t('common.category')}`,
      name: CATEGORY,
      required: true,
    },
    [SUBMISSION_TYPE]: {
      label: `${t('common.submission-type')}`,
      name: SUBMISSION_TYPE,
      required: true,
    },
    [ASSESSMENT_TYPE]: {
      label: `${t('common.assessment-type')}`,
      name: ASSESSMENT_TYPE,
      required: true,
    },

    [ACADEMIC_PERIOD]: {
      label: `${t('school.academic-period')}`,
      name: ACADEMIC_PERIOD,
      required: true
    },
    [EFFECTIVE_DATETIME]: {
      label: `${t('common.effective-date')}`,
      name: EFFECTIVE_DATETIME,
      required: true,
    },
    [DUE_DATETIME]: {
      label: `${t('common.due-date')}`,
      name: DUE_DATETIME,
      required: true,
    },
    [RESUBMISSION_DATETIME]: {
      label: `${t('common.resubmission-date')}`,
      name: RESUBMISSION_DATETIME,
    },
    [EXPECTED_TIME]: {
      label: `${t('common.expected-time')}`,
      name: EXPECTED_TIME,
      type: 'number',
      required: true,
    },
    [EXPECTED_TIME_TYPE]: {
      label: `${t('common.expected-time-type')}`,
      name: EXPECTED_TIME_TYPE,
      required: true,
    },
    [TITLE]: {
      label: `${t('assignments.assignment-name')}`,
      name: TITLE,
      required: true,
    },
    [COLOR]: {
      label: `${t('common.color')}`,
      name: COLOR,
    },
    [SCORE_TYPE]: {
      label: `${t('common.score-type')}`,
      name: SCORE_TYPE,
      required: true,
    },
    [DESCRIPTION]: {
      label: `${t('common.assignment-instructions')}`,
      name: DESCRIPTION,
    },
    [ATTACHMENTS]: {
      label: `${t('common.attachments')}`,
      name: ATTACHMENTS,
    },

    [ALLOW_SUBMISSIONS]: {
      label: `${t('assignments.allow-submissions')}`,
      name: ALLOW_SUBMISSIONS,
    },
    [ALLOW_COMMENTS]: {
      label: `${t('assignments.allow-discussion')}`,
      name: ALLOW_COMMENTS,
    },
    [ALLOW_ACCOMMODATION]: {
      label: `${t('rti.has-accommodations')}`,
      name: ALLOW_ACCOMMODATION,
    },
    [ALLOW_MODIFICATION]: {
      label: `${t('rti.has-modifications')}`,
      name: ALLOW_MODIFICATION,
    },

    [ACCOMMODATIONS]: {
      label: `${t('common.accommodations')}`,
      name: ACCOMMODATIONS,
    },
    [MODIFICATIONS]: {
      label: `${t('common.modifications')}`,
      name: MODIFICATIONS,
    },

    [DUE_DATETIME_EMAIL_NOTIFICATIONS]: {
      label: `${t('common.due-date-send-reminders')}`,
      name: DUE_DATETIME_EMAIL_NOTIFICATIONS,
    },
    [EFFECTIVE_DATETIME_EMAIL_NOTIFICATIONS]: {
      label: `${t('common.effective-date-send-reminders')}`,
      name: EFFECTIVE_DATETIME_EMAIL_NOTIFICATIONS,
    },

    [HAS_PEER_ASSESSMENT]: {
      label: `${t('common.peer-assessments')}`,
      name: HAS_PEER_ASSESSMENT,
    },
    [IS_PEER_ASSESSMENT_ANONYMOUS]: {
      label: `${t('common.anonymous-peer-assessments')}`,
      name: IS_PEER_ASSESSMENT_ANONYMOUS,
    },
    [PEER_ASSESSMENT_DUE_DATETIME]: {
      label: `${t('common.peer-assessments-due-datetime')}`,
      name: PEER_ASSESSMENT_DUE_DATETIME,
    },
    [PEER_ASSESSMENT_SUBMISSIONS_COUNT]: {
      label: `${t('common.peer-assessments-submission-count')}`,
      name: PEER_ASSESSMENT_SUBMISSIONS_COUNT,
    },
    [PEER_ASSESSMENT_INSTRUCTIONS]: {
      label: `${t('common.peer-assessments-instructions')}`,
      name: PEER_ASSESSMENT_INSTRUCTIONS,
    },


    // Grading
    [RUBRIC]: {
      label: `${t('common.rubric')}`,
      name: RUBRIC,
    },
    [POINTS_POSSIBLE]: {
      label: `${t('assignments.points-possible')}`,
      name: POINTS_POSSIBLE,
      type: 'number',
    },

    [IMPORTANCE]: {
      label: `${t('common.weight')}`,
      name: IMPORTANCE,
      required: true,
    },
    [NUMBER_OF_ATTEMPTS]: {
      label: `${t('assignments.number-of-attempts')}`,
      name: NUMBER_OF_ATTEMPTS,
      required: true,
    },
    [HAS_ENTRY_POINTS]: {
      label: `${t('assignments.has-entry-points')}`,
      name: HAS_ENTRY_POINTS,
    },
    [HAS_EXTRA_CREDIT]: {
      label: `${t('assignments.extra-credit')}`,
      name: HAS_EXTRA_CREDIT,
    },
    [EXTRA_CREDIT]: {
      label: `${t('assignments.extra-credit')}`,
      name: EXTRA_CREDIT,
      type: 'number'
    },
    [ENTRY_POINTS]: {
      label: `${t('assignments.entry-points')}`,
      name: ENTRY_POINTS,
      type: 'number',
    },
    [COUNTS_TO_FINAL_GRADE]: {
      label: `${t('assignments.counts-in-final-grade')}`,
      name: COUNTS_TO_FINAL_GRADE,
    },
    [ASSESSMENT_PROBE]: {
      label: `${t('assignments.assessment-probe')}`,
      name: ASSESSMENT_PROBE,
    },
    [GRADING_COMPONENTS]: {
      label: `${t('assignments.grading-components')}`,
      name: GRADING_COMPONENTS,
    },
    [RECIPIENT_TYPE]: {
      label: `${t('assignments.recipients-type')}`,
      name: RECIPIENT_TYPE,
      required: true,
    },
    [TEAM]: {
      label: `${t('assignments.class-group')}`,
      name: TEAM,
    },
    [STUDENTS]: {
      label: `${t('assignments.individual-students')}`,
      name: STUDENTS,
    },

  
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  // Section 1
  [GROUP]: null,
  [GROUP_COURSE]: null,
  [CHAPTER]: null,
  [SESSION]: null,
  [TEACHER]: null,
  [STATUS]: { id: 'draft', title: `${t('common.draft')}` },
  // Section 2

  [CATEGORY]: null,
  [SUBMISSION_TYPE]: null,
  [ASSESSMENT_TYPE]: null,
  [MATERIALS]: [],

  [ACADEMIC_PERIOD]: null,
  [EFFECTIVE_DATETIME]: null,
  [DUE_DATETIME]: null,
  [RESUBMISSION_DATETIME]: null,

  [EXPECTED_TIME]: '',
  [EXPECTED_TIME_TYPE]: null,

  [TITLE]: '',
  [COLOR]: '',
  [SCORE_TYPE]: null,
  [DESCRIPTION]: '',
  // [SCORE_TYPE]: { id: t('common.percentage').toLowerCase(), title: t('common.percentage') },

  [ALLOW_SUBMISSIONS]: false,
  [ALLOW_COMMENTS]: false,
  [ALLOW_ACCOMMODATION]: false,
  [ALLOW_MODIFICATION]: false,

  [ACCOMMODATIONS]: [{
    category: null,
    items: []
  },],
  [MODIFICATIONS]: [{
    category: null,
    items: []
  },],

  [DUE_DATETIME_EMAIL_NOTIFICATIONS]: false,
  [EFFECTIVE_DATETIME_EMAIL_NOTIFICATIONS]: false,

  [HAS_PEER_ASSESSMENT]: false,
  [IS_PEER_ASSESSMENT_ANONYMOUS]: false,
  [PEER_ASSESSMENT_DUE_DATETIME]: '',
  [PEER_ASSESSMENT_SUBMISSIONS_COUNT]: '',
  [PEER_ASSESSMENT_INSTRUCTIONS]: '',

  
  // Grading

  [RUBRIC]: null,
  [POINTS_POSSIBLE]: '',
  [IMPORTANCE]: { id: 5, title: '5' },
  [NUMBER_OF_ATTEMPTS]: { id: 1, title: '1' },
  [HAS_EXTRA_CREDIT]: false,
  [HAS_ENTRY_POINTS]: false,
  [EXTRA_CREDIT]: '0',
  [ENTRY_POINTS]: '0',
  [COUNTS_TO_FINAL_GRADE]: false,
  [ASSESSMENT_PROBE]: false,
  [GRADING_COMPONENTS]: [],
  [RECIPIENT_TYPE]: { id: 'everyone', title: `${t('assignments.everyone-in-class')}` },
  [TEAM]: null,
  [STUDENTS]: [],
}

/**
 * Form data validation
 */
export const validationSchema = (userRole: string) =>
  yup.object().shape({
    [GROUP]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [GROUP_COURSE]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [SUBMISSION_TYPE]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [ASSESSMENT_TYPE]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [ACADEMIC_PERIOD]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [TITLE]: yup.string().required(`${t('errors.required-error-message')}`),
    [EXPECTED_TIME]: yup
      .number()
      .typeError(`${t('errors.required-error-message')}`)
      .min(1, `${t('errors.required-error-message')}`)
      .required(`${t('errors.required-error-message')}`),
    [EXPECTED_TIME_TYPE]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [EFFECTIVE_DATETIME]: yup
      .date()
      .nullable()
      .min(today, `${t('errors.past-date', { type: 'Effective' })}`)
      .required(`${t('errors.required-error-message')}`),
    [DUE_DATETIME]: yup
      .date()
      .min(yup.ref(EFFECTIVE_DATETIME), `${t('errors.before-date', { type: 'Due', beforeType: 'Effective' })}`)
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [RESUBMISSION_DATETIME]: yup
      .date()
      .min(yup.ref(DUE_DATETIME), `${t('errors.before-date', { type: 'Resubmission', beforeType: 'Due' })}`)
      .nullable(),
    [SCORE_TYPE]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [GRADING_COMPONENTS]: yup
      .array()
      .nullable()
      .required(`${t('errors.required-error-message')}`)
      .when(SCORE_TYPE, {
        is: true,
        then: yup.string().required(`${t('errors.required-error-message')}`),
      }),
    [IMPORTANCE]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [NUMBER_OF_ATTEMPTS]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [EXTRA_CREDIT]: yup.number().min(0).max(3),  
    [RECIPIENT_TYPE]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [TEAM]: yup
      .object()
      .nullable()
      .when(RECIPIENT_TYPE, {
        is: 'team',
        then: yup.object().required(`${t('errors.required-error-message')}`),
      }),
    [STUDENTS]: yup
      .array()
      .nullable()
      .when(RECIPIENT_TYPE, {
        is: 'students',
        then: yup.array().required(`${t('errors.required-error-message')}`),
      }),
  })

  export const validationSchemaPublished = (userRole: string) =>
    yup.object().shape({
    [DUE_DATETIME]: yup
      .date()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [RESUBMISSION_DATETIME]: yup
      .date()
      .min(yup.ref(DUE_DATETIME), `${t('errors.before-date', { type: 'Resubmission', beforeType: 'Due' })}`)
      .nullable(),
  })

export default formModel
